// extracted by mini-css-extract-plugin
export var banner = "_hr-0";
export var closeButton = "_hr-2";
export var greenCheckmark = "_hr-3";
export var hereLink = "_hr-4";
export var titleIcon = "_hr-1";